<template>
  <div v-if="show">

    <div class="input_container">
      <weex-text class="input_label">{{usernameLabel}}</weex-text>
      <input
        class="input_with_border_bottom"
        :value="username"
        @input="username=$event.target.value"/>
    </div>

    <div class="input_container">
      <weex-text class="input_label">{{passwordLabel}}</weex-text>
      <input
        class="input_with_border_bottom"
        type="password"
        :value="password"
        @input="password=$event.target.value"/>
    </div>


    <wxc-button
      :text="loginText"
      class="horizontal_center margin-top-30"
      type="blue"
      @wxcButtonClicked="onLoginClicked"
      ></wxc-button>
  </div>
</template>

<script>

  import WxcButton from "../../../weex-ui/packages/wxc-button/index";
  import { MessageConstants } from "../../utils/MessageConstantUtil";
  import AlertService from "../core/alert/AlertService";

  export default {
    name: 'CallAndVerifyView',
    components: { WxcButton },

    data: () => ({
      username: "",
      password: ""
    }),

    props: {
      show: {
        type: Boolean,
        required: true,
        default: false
      },

      usernameLabel: {
        type: String,
        default: "Username"
      },

      passwordLabel: {
        type: String,
        default: "Password"
      },

      loginText: {
        type: String,
        default: "Login"
      }
    },

    methods: {
      showToast(message) {
        AlertService.showToast(message);
      },

      onLoginClicked() {
        if (this.checkForValidation()) {
          this.$emit("onLoginClicked", { username: this.username, password: this.password });
        }
      },

      checkForValidation() {
        if (!this.username) {
          this.showToast(MessageConstants.ENTER_USERNAME);
          return false;
        }

        if (!this.password) {
          this.showToast(MessageConstants.ENTER_PASSWORD);
          return false;
        }
        return true;
      },

      clearPassword() {
        this.password = "";
      }
    }
  }
</script>

<style
  scoped
  src="../../assets/style/base.css"></style>
